/* HIKE Comfort clone – interaction layer (replaces Next.js hydration) */
(function () {
  'use strict';
  var CFG = window.HIKE_CFG || {};
  var PRODUCT = window.HIKE_PRODUCT || null;
  var GALLERY = window.HIKE_GALLERY || {};
  var ASSET_BASE = (window.HIKE_ASSET_BASE || '').replace(/\/[^\/]*(\?.*)?$/, '/');
  var COLORS = ['Beige', 'Schwarz', 'Grau'];
  var state = { color: 'Beige', size: '37', qty: 1 };

  function assetUrl(name) { return /^https?:|^\/\//.test(name) ? name : ASSET_BASE + name; }
  function eur(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function textEls(root, needle) {
    var out = [];
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    while (w.nextNode()) {
      var n = w.currentNode;
      if (n.nodeValue && n.nodeValue.indexOf(needle) !== -1) out.push(n);
    }
    return out;
  }

  /* ---------- variant resolution ---------- */
  function findVariant(color, size) {
    if (!PRODUCT || !PRODUCT.variants) return null;
    for (var i = 0; i < PRODUCT.variants.length; i++) {
      var v = PRODUCT.variants[i];
      if ((v.option1 === color && String(v.option2) === String(size)) ||
          (v.option2 === color && String(v.option1) === String(size))) return v;
    }
    return null;
  }
  function sizeAvailable(color, size) {
    var v = findVariant(color, size);
    return v ? v.available !== false : true;
  }

  /* ---------- swatches ---------- */
  var swatches = Array.prototype.slice.call(document.querySelectorAll('button[aria-label^="Select "]'));
  var selTemplate = null, unselTemplate = null;
  swatches.forEach(function (b) {
    var c = b.getAttribute('aria-label').replace('Select ', '');
    b.dataset.hikeColor = c;
    if (c === 'Beige') selTemplate = b.getAttribute('style') || '';
    else if (unselTemplate === null) unselTemplate = b.getAttribute('style') || '';
  });
  function swatchRing(btn) {
    var dot = btn.querySelector('div[style*="background"]');
    var m = dot && (dot.getAttribute('style') || '').match(/background:([^;]+)/);
    return m ? m[1] : '#528125';
  }
  function updateSwatches() {
    swatches.forEach(function (b) {
      if (b.dataset.hikeColor === state.color) {
        b.style.background = swatchRing(b);
        b.style.padding = '2px';
      } else {
        b.style.background = 'transparent';
        b.style.padding = '2px';
      }
    });
  }

  /* ---------- size pills ---------- */
  var SIZES = ['37','38','39','40','41','42','43','44','45','46'];
  var sizeBtns = [];
  Array.prototype.slice.call(document.querySelectorAll('button')).forEach(function (b) {
    var t = (b.textContent || '').trim();
    if (SIZES.indexOf(t) !== -1 && !b.dataset.hikeSize) { b.dataset.hikeSize = t; sizeBtns.push(b); }
  });
  var sizeBase = 'px-4 py-2 min-w-[3rem] rounded-md border text-sm font-medium transition-all duration-200 cursor-pointer';
  var sizeSelCls = sizeBase + ' border-green bg-green-light text-green';
  var sizeUnselCls = sizeBase + ' border-green text-green hover:bg-green-light';
  var sizeDisCls = sizeBase + ' border-gray-200 text-gray-300 cursor-not-allowed';
  function updateSizes() {
    sizeBtns.forEach(function (b) {
      var s = b.dataset.hikeSize;
      var avail = sizeAvailable(state.color, s);
      b.className = (s === state.size) ? sizeSelCls : (avail ? sizeUnselCls : sizeDisCls);
      b.disabled = false;
      b.setAttribute('aria-pressed', s === state.size ? 'true' : 'false');
    });
  }

  /* ---------- labels (Farbe: X  Größe: Y) ---------- */
  function updateLabels() {
    document.querySelectorAll('span,p,div').forEach(function (el) {
      if (el.children.length > 2) return;
      var t = el.textContent || '';
      if (/^Farbe:\s/.test(t.trim()) && t.length < 30) el.innerHTML = 'Farbe: <b>' + state.color + '</b>';
      else if (/^Größe:\s/.test(t.trim()) && t.length < 30) el.innerHTML = 'Größe: <b>' + state.size + '</b>';
    });
  }

  /* ---------- gallery ---------- */
  function updateGallery() {
    var list = GALLERY[state.color] || [];
    var main = document.getElementById('vw-main');
    var thumbs = document.getElementById('vw-thumbs');
    if (!main || !list.length) return;
    main.src = assetUrl(list[0]);
    main.setAttribute('alt', 'VitaWalk ' + state.color);
    if (!thumbs) return;
    thumbs.innerHTML = '';
    list.forEach(function (name, idx) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vw-thumb aspect-square rounded-lg overflow-hidden bg-[#f5f9f3] border-2 ' + (idx === 0 ? 'border-[#388422]' : 'border-transparent');
      var im = document.createElement('img');
      im.src = assetUrl(name);
      im.className = 'w-full h-full object-contain';
      im.setAttribute('alt', 'VitaWalk ' + state.color + ' ' + (idx + 1));
      b.appendChild(im);
      b.addEventListener('click', function () {
        main.src = assetUrl(name);
        Array.prototype.forEach.call(thumbs.children, function (c) {
          c.className = c.className.replace('border-[#388422]', 'border-transparent');
        });
        b.className = b.className.replace('border-transparent', 'border-[#388422]');
      });
      thumbs.appendChild(b);
    });
  }

  /* ---------- price ---------- */
  function updatePrice() {
    var v = findVariant(state.color, state.size);
    if (!v) return;
    textEls(document.body, '89,99').forEach(function (n) { n.nodeValue = n.nodeValue.replace(/\d+,\d+\s*€/, eur(v.price)); });
    if (v.compare_at_price) textEls(document.body, '119,99').forEach(function (n) { n.nodeValue = n.nodeValue.replace(/\d+,\d+\s*€/, eur(v.compare_at_price)); });
  }

  /* ---------- sticky bar selects ---------- */
  var stickySelects = Array.prototype.slice.call(document.querySelectorAll('select'));
  stickySelects.forEach(function (s) {
    var vals = Array.prototype.map.call(s.options, function (o) { return o.value || o.textContent.trim(); });
    if (vals.indexOf('Beige') !== -1 || vals.indexOf('Schwarz') !== -1) s.dataset.hikeRole = 'color';
    else if (vals.indexOf('36') !== -1 || vals.indexOf('38') !== -1) s.dataset.hikeRole = 'size';
    s.addEventListener('change', function () {
      if (s.dataset.hikeRole === 'color') setColor(s.value);
      if (s.dataset.hikeRole === 'size') setSize(s.value);
    });
  });
  function syncSelects() {
    stickySelects.forEach(function (s) {
      if (s.dataset.hikeRole === 'color') s.value = state.color;
      if (s.dataset.hikeRole === 'size') s.value = state.size;
    });
  }

  function setColor(c) {
    state.color = c;
    if (!sizeAvailable(c, state.size)) {
      var alt = ['37','38','39','40','41','42','43','44','45','46'].filter(function (s) { return sizeAvailable(c, s); })[0];
      if (alt) state.size = alt;
    }
    updateSwatches(); updateSizes(); updateLabels(); updateGallery(); updatePrice(); syncSelects(); updateUrl(); if(typeof syncFirstPair==='function') syncFirstPair();
  }
  function setSize(s) { state.size = s; updateSizes(); updateLabels(); updatePrice(); syncSelects(); updateUrl(); if(typeof syncFirstPair==='function') syncFirstPair(); }
  function updateUrl() {
    var v = findVariant(state.color, state.size);
    if (v && history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
  }
  swatches.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); setColor(b.dataset.hikeColor); }); });
  sizeBtns.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); setSize(b.dataset.hikeSize); }); });

  /* ---------- bundles + per-pair selection ---------- */
  var COLOR_THUMB = { 'Beige': 'vw-sw-beige.webp', 'Schwarz': 'vw-sw-black.webp', 'Grau': 'vw-sw-grey.webp' };
  var bundleQty = 1;
  var bundlePairs = [{ color: state.color, size: state.size }];
  function renderPairs() {
    var wrap = document.getElementById('vw-pairs');
    if (!wrap) return;
    var hint = document.getElementById('vw-pairs-hint');
    if (hint) hint.classList.toggle('hidden', bundlePairs.length < 2);
    wrap.innerHTML = '';
    bundlePairs.forEach(function (pair, i) {
      var thumbs = COLORS.map(function (c) {
        var sel = c === pair.color;
        return '<button type="button" data-pi="' + i + '" data-color="' + c + '" title="' + c + '" style="border:2px solid ' + (sel ? '#388422' : '#e5e7eb') + '" class="vw-pc w-9 h-9 rounded-md overflow-hidden shrink-0"><img src="' + assetUrl(COLOR_THUMB[c]) + '" class="w-full h-full object-contain" alt="' + c + '"/></button>';
      }).join('');
      var opts = SIZES.map(function (s) { return '<option value="' + s + '"' + (s === pair.size ? ' selected' : '') + '>Gr. ' + s + '</option>'; }).join('');
      var row = document.createElement('div');
      row.className = 'flex items-center gap-2 border rounded-lg p-2.5';
      row.innerHTML =
        '<span class="text-sm font-semibold text-[#1a1f15] shrink-0 w-12">Paar ' + (i + 1) + '</span>' +
        '<div class="flex items-center gap-1.5 flex-grow">' + thumbs + '</div>' +
        '<select data-pi="' + i + '" class="vw-ps border rounded-md text-sm px-2 py-1.5 shrink-0" style="background:#fff">' + opts + '</select>';
      wrap.appendChild(row);
    });
    wrap.querySelectorAll('.vw-pc').forEach(function (b) {
      b.addEventListener('click', function () { bundlePairs[+b.getAttribute('data-pi')].color = b.getAttribute('data-color'); renderPairs(); });
    });
    wrap.querySelectorAll('.vw-ps').forEach(function (sel) {
      sel.addEventListener('change', function () { bundlePairs[+sel.getAttribute('data-pi')].size = sel.value; });
    });
  }
  function selectBundle(n) {
    bundleQty = n;
    while (bundlePairs.length < n) bundlePairs.push({ color: state.color, size: state.size });
    bundlePairs.length = n;
    renderPairs();
    document.querySelectorAll('[data-vw-bundle]').forEach(function (c) {
      var on = parseInt(c.getAttribute('data-vw-bundle'), 10) === n;
      c.style.border = '2px solid ' + (on ? '#388422' : '#e5e7eb');
      c.style.background = on ? '#f5f9f3' : '';
    });
  }
  function syncFirstPair() { if (bundlePairs && bundlePairs[0]) { bundlePairs[0].color = state.color; bundlePairs[0].size = state.size; renderPairs(); } }
  document.querySelectorAll('[data-vw-bundle]').forEach(function (card) {
    card.addEventListener('click', function () { selectBundle(parseInt(card.getAttribute('data-vw-bundle'), 10) || 1); });
  });
  renderPairs();

  /* ---------- cart drawer ---------- */
  var root = document.getElementById('hike-drawer-root');
  function drawerOpen(pending) {
    if (!root) return;
    root.classList.remove('hidden');
    requestAnimationFrame(function () {
      document.getElementById('hike-drawer-overlay').classList.remove('opacity-0');
      document.getElementById('hike-drawer-panel').classList.remove('translate-x-full');
    });
    document.body.style.overflow = 'hidden';
    if (pending) { showPending(); return; }
    refreshCart();
  }
  function showPending() {
    var wrap = document.getElementById('hike-drawer-items');
    if (!wrap) return;
    wrap.innerHTML = '<div class="border rounded-xl p-3 flex gap-3 animate-pulse">' +
      '<div class="w-24 h-24 rounded-lg bg-gray-100"></div>' +
      '<div class="flex-1 space-y-2 py-1"><div class="h-3 w-3/4 bg-gray-100 rounded"></div>' +
      '<div class="h-3 w-1/2 bg-gray-100 rounded"></div><div class="h-3 w-1/3 bg-gray-100 rounded"></div></div></div>';
  }
  function drawerClose() {
    if (!root) return;
    document.getElementById('hike-drawer-overlay').classList.add('opacity-0');
    document.getElementById('hike-drawer-panel').classList.add('translate-x-full');
    document.body.style.overflow = '';
    setTimeout(function () { root.classList.add('hidden'); }, 320);
  }
  if (root) {
    document.getElementById('hike-drawer-close').addEventListener('click', drawerClose);
    document.getElementById('hike-drawer-overlay').addEventListener('click', drawerClose);
    document.getElementById('hike-drawer-checkout').addEventListener('click', function () {
      /* No link decorator can catch a location.href, so this is done by hand.
         /checkout is a redirect endpoint and Shopify STRIPS its query string, so the
         utm set would die here. A /cart/<id>:<qty> permalink keeps both the params and
         attributes[...], so the cart is re-expressed as a permalink when it is safe to:
         plain lines only, no line item properties and no selling plans, since a
         permalink would drop those. Otherwise fall back to /checkout, where the cart
         attributes stamped by vw-attr.js still carry the attribution onto the order. */
      var plain = '/checkout';
      if (!window.vwAttr || !window.vwAttr.active) { location.href = plain; return; }
      var fallback = window.vwAttr.decorate(plain);
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var items = (c && c.items) || [];
          if (!items.length) { location.href = fallback; return; }
          for (var i = 0; i < items.length; i++) {
            var it = items[i];
            if (it.selling_plan_allocation) throw 0;
            if (it.properties && Object.keys(it.properties).length) throw 0;
          }
          var parts = items.map(function (it) { return it.variant_id + ':' + it.quantity; });
          location.href = window.vwAttr.decorateCheckout('/cart/' + parts.join(','));
        })
        .catch(function () { location.href = fallback; });
    });
  }
  function cdnSized(u, w) {
    if (!u) return '';
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function colorThumb(color) {
    var l = GALLERY[color];
    return l && l.length ? assetUrl(l[0]) : '';
  }
  function renderCart(cart) {
    var count = cart.item_count;
    document.getElementById('hike-drawer-count').textContent = count;
    document.getElementById('hike-drawer-count2').textContent = count;
    document.getElementById('hike-drawer-sub').textContent = count + ' Artikel im Warenkorb';
    document.getElementById('hike-drawer-subtotal').textContent = eur(cart.items_subtotal_price);
    document.getElementById('hike-drawer-total').textContent = eur(cart.total_price);
    var wrap = document.getElementById('hike-drawer-items');
    wrap.innerHTML = '';
    cart.items.forEach(function (it) {
      var color = it.options_with_values ? (it.options_with_values.filter(function (o) { return o.name === 'Farbe'; })[0] || {}).value : (it.variant_options || [])[0];
      var size = it.options_with_values ? (it.options_with_values.filter(function (o) { return o.name === 'Größe'; })[0] || {}).value : (it.variant_options || [])[1];
      var img = cdnSized(it.image || colorThumb(color) || '', 200);
      var div = document.createElement('div');
      div.className = 'border rounded-xl p-3 flex gap-3 relative';
      div.innerHTML =
        '<img src="' + img + '" class="w-24 h-24 rounded-lg object-cover bg-gray-50" alt=""/>' +
        '<div class="flex-1 min-w-0">' +
        '<div class="font-semibold text-sm leading-snug pr-6" style="display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden">' + it.product_title + '</div>' +
        '<div class="flex items-center gap-1.5 mt-1">' +
        (color ? '<span class="bg-gray-100 text-xs rounded px-2 py-0.5">' + color + '</span>' : '') +
        (size ? '<span class="text-gray-400 text-xs">·</span><span class="bg-gray-100 text-xs rounded px-2 py-0.5">' + size + '</span>' : '') +
        '</div>' +
        '<div class="text-[#c0392b] text-xs font-semibold mt-1">1.1K+ in den letzten 7 Tagen verkauft</div>' +
        '<div class="flex items-center justify-between mt-2">' +
        '<div class="inline-flex items-center border rounded-lg overflow-hidden">' +
        '<button class="px-2.5 py-1 text-lg leading-none" data-hike-minus>−</button>' +
        '<span class="px-2 text-sm font-semibold">' + it.quantity + '</span>' +
        '<button class="px-2.5 py-1 text-lg leading-none" data-hike-plus>+</button></div>' +
        '<div class="text-right">' +
        '<div class="text-gray-400 line-through text-xs">' + eur((PRODUCT && PRODUCT.compare_at_price) || it.original_line_price * 0 + Math.round(it.final_price * 119.99 / 79.99)) + '</div>' +
        '<div class="font-bold">' + eur(it.final_line_price) + '</div></div>' +
        '</div>' +
        '<div class="flex gap-3 mt-1.5"><a href="#" class="text-xs underline text-gray-600" data-hike-change="color">Farbe ändern</a><a href="#" class="text-xs underline text-gray-600" data-hike-change="size">Größe ändern</a></div>' +
        '</div>' +
        '<button class="absolute top-3 right-3 text-gray-400 hover:text-black" data-hike-remove><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg></button>';
      div.querySelector('[data-hike-minus]').addEventListener('click', function () { changeQty(it.key, it.quantity - 1); });
      div.querySelector('[data-hike-plus]').addEventListener('click', function () { changeQty(it.key, it.quantity + 1); });
      div.querySelector('[data-hike-remove]').addEventListener('click', function () { changeQty(it.key, 0); });
      div.querySelectorAll('[data-hike-change]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); drawerClose(); }); });
      wrap.appendChild(div);
    });
  }
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  function changeQty(key, q) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  /* ---------- add to cart ---------- */
  function addToCart() {
    var items = [];
    bundlePairs.forEach(function (p) { var v = findVariant(p.color, p.size); if (v) items.push({ id: v.id, quantity: 1 }); });
    if (window.vwTrack && items.length) window.vwTrack('AddToCart', {
      value: items.length * 89.99, currency: 'EUR', num_items: items.length,
      content_type: 'product', content_ids: ['flame']
    });
    if (!items.length) { drawerOpen(); return; }
    drawerOpen(true);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(); })
      .catch(function () { refreshCart(); });
  }
  document.querySelectorAll('button, a').forEach(function (b) {
    var t = (b.textContent || '').replace(/\s+/g, ' ').trim();
    if (/IN DEN WARENKORB/i.test(t) && t.length < 60) {
      b.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });
    }
  });
  /* header cart icon opens drawer */
  document.querySelectorAll('a[href*="/cart"], button[aria-label*="cart" i], button[aria-label*="Warenkorb" i]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); drawerOpen(); });
  });

  /* ---------- reviews scroll ---------- */
  document.querySelectorAll('button,a,span').forEach(function (b) {
    var t = (b.textContent || '').trim();
    if (/Bewertungen\)/.test(t) && t.length < 40) {
      b.style.cursor = 'pointer';
      b.addEventListener('click', function () {
        var r = document.getElementById('looxReviews');
        if (r) r.scrollIntoView({ behavior: 'smooth' });
      });
    }
  });

  /* ---------- init ---------- */
  updateSwatches(); updateSizes(); updateLabels(); syncSelects(); updatePrice(); updateGallery();
})();
